import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.css';

//
// Initialize full height screen
//
document.body.classList.remove(
    'd-flex',
    'flex-column',
    'vh-100'
);
document.body.classList.add(
    'd-flex',
    'flex-column',
    'vh-100'
);

document.getElementById('root')?.classList.remove(
    'd-flex',
    'flex-column',
    'h-100'
);

document.getElementById('root')?.classList.add(
    'd-flex',
    'flex-column',
    'h-100'
);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();